export default __webpack_public_path__ + "static/media/coupon_received.a4cba7cb.png";